import { useEffect, useState } from "react";

const isTextField = (el) =>
  el && (el.tagName === "TEXTAREA" || (el.tagName === "INPUT" && !["checkbox", "radio", "button", "submit"].includes(el.type)));

// True while a text field is focused on a touch device (on-screen keyboard is up); keeps the field in view.
export function useKeyboardOpen() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!window.matchMedia("(pointer: coarse)").matches) return;
    const onIn = (e) => {
      if (!isTextField(e.target)) return;
      setOpen(true);
      setTimeout(() => e.target.scrollIntoView({ block: "center", behavior: "smooth" }), 350);
    };
    const onOut = () => setTimeout(() => setOpen(isTextField(document.activeElement)), 50);
    document.addEventListener("focusin", onIn);
    document.addEventListener("focusout", onOut);
    return () => {
      document.removeEventListener("focusin", onIn);
      document.removeEventListener("focusout", onOut);
    };
  }, []);
  return open;
}
